import { Download1Stroke, EyeStroke, Pencil1Stroke, PlusStroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

interface ActionBarProps {
  onAddClick: () => void;
  onEditClick: () => void;
  onDeleteClick: () => void;
  onCopyClick: () => void;
  onViewClick: () => void;
  onRefreshClick: () => void;
}

const ActionBar = ({
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onViewClick,
  onRefreshClick
}: ActionBarProps) => (
  <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Danh mục khu vực</h1>}>
    <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddClick} variant='primary' />
    <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} />
    <ActionButtonV2 icon={Trash3Stroke} title='Xoá' variant='destructive' onClick={onDeleteClick} />
    <ActionButtonV2 icon={Download1Stroke} title='Sao chép' onClick={onCopyClick} />
    <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onViewClick} />
    <MenuButtonV2
      items={[
        {
          title: 'Refresh',
          icon: <AritoIcon icon={15} />,
          onClick: onRefreshClick,
          group: 0
        },
        {
          title: 'Cố định cột',
          icon: <AritoIcon icon={16} />,
          onClick: () => {},
          group: 0
        },
        {
          title: 'Kết xuất dữ liệu',
          icon: <AritoIcon icon={555} />,
          onClick: () => {},
          group: 1
        }
      ]}
    />
  </ActionBarV2>
);

export default ActionBar;
